export enum AppType {
  MOBILE = 'mobile',
  QR = 'qr',
  SERVICE = 'service',
  CRM = 'web',
  WEBCON = 'webcon',
  /** Fliko estate link */
  WWW = 'www'
}
